var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.0199 137.908C107.501 137.908 137.886 107.523 137.886 70.0419C137.886 32.5604 107.501 2.17578 70.0199 2.17578C32.5385 2.17578 2.15381 32.5604 2.15381 70.0419C2.15381 107.523 32.5385 137.908 70.0199 137.908Z",
    fill: "#FF9F24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.633 83.3667C134.016 52.089 114.644 20.7488 83.3666 13.3666C52.0889 5.98443 20.7489 25.3556 13.3667 56.6333C5.98446 87.911 25.3556 119.251 56.6333 126.633C87.911 134.015 119.251 114.644 126.633 83.3667Z",
    fill: "#FF9F24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8124 38.0952C67.0457 33.9732 72.9614 33.9735 75.1943 38.0958L100.779 85.3291C102.91 89.2627 100.062 94.0446 95.588 94.0446H44.412C39.9381 94.0446 37.0899 89.2622 39.2212 85.3285L64.8124 38.0952Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0024 70.8545V53.3545",
    stroke: "#FF9F24",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 81.3984,
    r: 3.5,
    fill: "#FF9F24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningicon);
export default __webpack_public_path__ + "static/media/Warningicon.4205903f6a3c8e8825684d15cf15a2c1.svg";
export { ForwardRef as ReactComponent };